/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import { getCookie } from 'cookies-next';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import configEnv from '@/services/env.production';

import logoCloudBlue from '@/assets/images/logo-blue-header.svg';
import logoCloudWhite from '@/assets/images/logo-cloud.svg';
import Burger from '@/components/burger';
import { NAVBAR } from '@/constants';
// import useResponsive from '@/hooks/useResponsive';
import NavSectionVertical from '@/layouts/header/components/MobileMenu';
import { StyledMenu } from '@/styles/styled';
import SelectLanguage from '@/layouts/header/components/SelectLanguage';

const DocumentHeader = ({ headerData }) => {
  const { t } = useTranslation('header');
  const theme = useTheme();
  const router = useRouter();
  // const isDesktop = useResponsive('up', 'sm');
  const [mobileOpen, setMobileOpen] = useState(false);

  const container = typeof window !== 'undefined' ? () => window.document.body : undefined;

  const handleCloseMenu = () => {
    setMobileOpen(false);
  };

  const handleChangeRoutes = (value) => {
    window.open(value, '_blank');
  };

  useEffect(() => {
    handleCloseMenu();
  }, [router.asPath]);

  return (
    <Box
      sx={{
        display: 'flex',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: 69,
        zIndex: { xs: 1305, md: 100 },
      }}
    >
      <CssBaseline />
      <AppBar
        position="static"
        sx={{
          background: theme.palette.background.default,
          '@media (min-width: 1600px)': { px: 5 },
        }}
      >
        <Toolbar
          sx={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: { xs: '100%', md: 'auto' },
              '@media (min-width: 1280px)': { mx: 2 },
              '@media (min-width: 1600px)': { mr: 5 },
            }}
          >
            <Link passHref href="/">
              <Image
                alt="CMC Cloud"
                width={80}
                src={theme.palette.mode === 'dark' ? logoCloudWhite : logoCloudBlue}
              />
            </Link>
          </Box>
          {/* Right navbar */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mr: { xs: 7, md: 0 },
              gap: 1,
              '@media (min-width: 1600px)': { gap: 2 },
            }}
          >
            <Box
              sx={{
                flexGrow: 0,
                display: { xs: 'none', md: 'flex' },
                alignItems: 'center',
                gap: 2,
                '@media (min-width: 1600px)': { gap: 1 },
              }}
            >
              <SelectLanguage />
              <Button
                sx={{
                  px: 2,
                  color: '#4F4A4B',
                  background: `transparent !important`,
                  border: 'solid 1px #D1D1D1',
                  borderRadius: '6px',
                  '&:hover': {
                    color: theme.palette.text.white,
                    background: `${theme.palette.background.blue} !important`,
                  },
                  textTransform: 'none',
                }}
                onClick={() =>
                  handleChangeRoutes(
                    `${configEnv.APP_SIGN_IN_URL}${getCookie('gtm_campaign') || ''}`
                  )
                }
              >
                {t('login')}
              </Button>
              <Button
                sx={{
                  px: 2,
                  color: theme.palette.text.white,
                  background: `${theme.palette.highlight} !important`,
                  borderRadius: '6px',
                  '&:hover': {
                    color: theme.palette.text.white,
                    background: `${theme.palette.background.blue} !important`,
                  },
                  textTransform: 'none',
                }}
                onClick={() =>
                  handleChangeRoutes(
                    `${configEnv.APP_REGISTER_ACCOUNT_URL}${getCookie('gtm_campaign') || ''}`
                  )
                }
              >
                {t('sign_up')}
              </Button>
            </Box>
            {/* <SelectLanguage /> */}
            {/* {process.env.NODE_ENV === 'development' && (
              <AppMode toggleThemeMode={toggleThemeMode} />
            )} */}
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <StyledMenu open={mobileOpen}>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleCloseMenu}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              width: { xs: '100vw !important', sm: NAVBAR.DASHBOARD_WIDTH },
              display: { xs: 'block', md: 'none' },
            }}
          >
            <NavSectionVertical
              navConfig={headerData}
              onClose={handleCloseMenu}
              childName="navbar_menus"
            />
          </Drawer>
        </StyledMenu>
        <Burger open={mobileOpen} setOpen={setMobileOpen} />
      </Box>
    </Box>
  );
};

export default DocumentHeader;
